// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dealerships_page_wrapper__Im8l_"};